import React, { Component } from "react";
import { getTranslation } from '../../assets/creator/translations';

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navbar: props.getNavBarWrapper,
            currentView: "elementRoot",
        }    
    }

    navbar = () => {
        return (
            <NavbarElementWrapper {...this.props} />
        )
    }

    render = () => (
        <React.Fragment>
            {LogoWrapper}
    {this.navbar()}
    </React.Fragment>
    )
}
export default Navbar;



function deleteDivGenerateBtnBlocker() {
	const blocker = document.querySelector(".generateBtnBlockerClass")
    const imgLastInfoModal=document.querySelector(".imgCloudFirst")
    const generateBtn = document.querySelector(".generate-btn")


    
    if(blocker!=null){
        blocker.remove()
        generateBtn.style.zIndex="0"
        
    }
    if(imgLastInfoModal!=null){

        imgLastInfoModal.remove();
    }

    
}

const NavbarElementWrapper= (props) => {
    let generateBtnClass = 'generate-btn-active generate-btn';
    if (!props.missingTypes || props.missingTypes.length > 0) {
        generateBtnClass = 'generate-btn-disabled generate-btn';
    }
    return (
        <div className='navbar__wrapper' onMouseOver={deleteDivGenerateBtnBlocker}>
                <NewProjectButton onClick={props.onNewProjectClick}  />
                <button
                    className="navbar__button-link"
                    onClick={props.onOpenImportTemplateModal}
                    //name="template-import"
                    accept="text/xml"
                >
                    {getTranslation("SendXmlFile")}
                </button>
                <button
                    onClick={props.onGenerate}
                    className={generateBtnClass}
                >
                    {getTranslation("Generate")}
                </button>
                
        </div>
    )
}

const NewProjectButton = ({onClick}) => (
    <button className="navbar__new-project" onClick={onClick}>
        {getTranslation("NewProject")}
    </button>
)

const LogoWrapper = (
    <div className='navbar__logo-wrapper'>
        <img src="../../img/comarch_logo.png" className="navbar__logo" alt="logo" />
    </div>
);


